import { IssueDetail } from "models/issue";
import { issuePathById } from "helpers/url/pages/v1";
import { useNavigate } from "react-router";
import OutlineTag from "components/Tag/OutlineTag";
import { TagProps } from "@chakra-ui/react";
import resolveIssueType, { expandedIssueTypeResolver } from "../Resolutions/resolveIssueType";
import { useIssueDetailQuery } from "../hooks";

function IssueTagBase({ children, ...rest }: TagProps) {
  return (
    <OutlineTag
      color="tagRed.text"
      borderColor="tagRed.bg"
      bg="tagRed.bg"
      border="none"
      cursor="pointer"
      height="20px"
      minHeight="18px"
      fontSize="xs"
      {...rest}
    >
      {children}
    </OutlineTag>
  );
}

export function IssueTag({ issue, ...rest }: { issue: Issue } & TagProps) {
  return (
    <IssueTagBase {...rest}>
      {resolveIssueType(issue)}
    </IssueTagBase>
  );
}

export function ExpandedIssueTag({ issue, ...rest }: { issue: Issue } & TagProps) {
  const issueTypeResolver = expandedIssueTypeResolver(issue);

  const { data: issueDetail, isFetched } = useIssueDetailQuery(issue?.id, {
    enabled: !!issueTypeResolver,
  });

  let issueText;

  if (issueTypeResolver && isFetched) {
    issueText = issueTypeResolver(issueDetail);
  } else {
    issueText = resolveIssueType(issue);
  }

  return (
    <IssueTagBase {...rest}>
      {issueText}
    </IssueTagBase>
  );
}

export function RedirectIssueTag({ issue }: { issue: IssueDetail }) {
  const navigate = useNavigate();
  return (
    <IssueTag issue={issue} onClick={() => navigate(issuePathById(issue?.id))} />
  );
}
